import request from "@/router/axios";

export const getPatientTodayTodo = (params) => {
  return request({
    url: "/api/ygj-datacenter/v1.0/workbench/patient-today-todo",
    method: "GET",
    params,
  });
};

//企微患者中心-今日待办-初诊信息
export const getPatientFirstVisit = (params) => {
  return request({
    url: "/api/ygj-datacenter/v1.0/workbench/patient-first-visit",
    method: "GET",
    params,
  });
};
